import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {AdvancedBookingsTimePage} from "../advanced-bookings-time/advanced-bookings-time";
import moment from 'moment';
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import { BarberBookingNewPage } from '../barber-booking-new/barber-booking-new';

@IonicPage()
@Component({
  selector: 'page-shop-staff-hours-popover',
  templateUrl: 'shop-staff-hours-popover.html',
})
export class ShopStaffHoursPopoverPage {

  shop: any;
  allStaff: any;
  selectedStaff: any;
  day: any;
  bookingDate: any;
  navCtrl: any;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public tabsService: TabsServiceProvider,
    public navController: NavController
  ) {
    this.shop = navParams.get('shop');
    this.allStaff = navParams.get('allStaff');
    this.selectedStaff = navParams.get('staff');
    this.day = navParams.get('day');
    this.navCtrl = navParams.get('navCtrl');
    // If navCtrl is not passed ot the view then use the ionic NavController.
    if (!this.navCtrl) this.navCtrl = this.navController;
  }

  title(staff) {
    if (staff.standard.end_at_string) {
      if (staff.standard.start_at_string){
        return `${staff.name} - ${staff.standard.start_at_string} to ${staff.standard.end_at_string}`;
      } else {
        return `${staff.name} - ${staff.standard.end_at_string}`;
      }
    }

    return staff.name;
  }

  openingTime(shop) {
    if (!shop.closed) {
      return shop.open_at_string + ' - ' + shop.close_at_string;
    }

    return 'Closed';
  }

  bookNow(staff) {
    this.allStaff.forEach(singleStaff => {
      if (singleStaff.id === staff.id) {
        staff = singleStaff;
      }
    });

    this.bookingDate = this.getBookingDate(this.day.name);

    this.viewCtrl.dismiss().then(()=>{
      this.tabsService.hide();
      // this.navCtrl.push(AdvancedBookingsTimePage, {
      //   date: this.bookingDate,
      //   shop: this.shop,
      //   barber: staff,
      //   byStaff: false
      // });

      this.navCtrl.push(BarberBookingNewPage, {
        shop: this.shop,
        byStaff: false,
        guestUser: null,
        isAdvanceBooking : true,
        barber: staff,
        date: this.bookingDate,
      });
    });
  }

  //@ref https://stackoverflow.com/a/39614998
  getBookingDate(day) {
    const today = moment().isoWeekday();
    let dayInNeed = moment().isoWeekday(day).weekday();

    // if we haven't yet passed the day of the week that I need:
    // for next day what he selected 
    // if (today <= dayInNeed) {
      if (today < dayInNeed) {
      // then just give me this week's instance of that day
      return moment().isoWeekday(dayInNeed).format('DD/MM/YYYY');
    }

    // otherwise, give me *next week's* instance of that same day
    return moment().add(1, 'weeks').isoWeekday(dayInNeed).format('DD/MM/YYYY');
  }

  isThisInFuture(targetDayNum) {
    // param: positive integer for weekday
    // returns: matching moment or false
    const todayNum = moment().isoWeekday();

    if (todayNum <= targetDayNum) {
      return moment().isoWeekday(targetDayNum);
    }
    return false;
  }

  closePopover() {
    this.viewCtrl.dismiss();
    this.tabsService.show();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shop-staff-hours-popover/shop-staff-hours-popover.ts